import { SHButton, SHDialog, SHStack } from "@components/design-systems";
import { AnalysisStep } from "@models/platform-analysis/enums/step";
import {
  AnalysisSetupStepDialogBodies,
  AnalysisSetupStepDialogHeaders,
} from "@pages/platform-analysis-v2/_id/steps/setup/constants";
import { useMemo } from "react";

type ConfirmDiscardStepsDialogProps = {
  open: boolean;
  discardedStages: AnalysisStep[];
  onDiscard: () => void;
  onClose: () => void;

  // eslint-disable-next-line @typescript-eslint/no-explicit-any -- Allow dynamic props
  [key: string]: any;
};

export const ConfirmDiscardStepsDialog = ({
  open = false,
  discardedStages = [],
  isPlural = discardedStages.length > 1,
  onDiscard,
  onClose,
}: ConfirmDiscardStepsDialogProps) => {
  const dialogHeader = useMemo(
    () =>
      isPlural
        ? AnalysisSetupStepDialogHeaders.DiscardedManyStages
        : AnalysisSetupStepDialogHeaders.DiscardedOneStage,
    [isPlural],
  );

  const dialogBody = useMemo(
    () =>
      isPlural
        ? AnalysisSetupStepDialogBodies.DiscardedManyStages
        : AnalysisSetupStepDialogBodies.DiscardedOneStage,
    [isPlural],
  );

  return (
    <SHDialog
      open={open}
      disableEscapeKeyDown
      disableBackdropClick
      maxWidth={false}
      sx={{
        "& .MuiPaper-root": {
          width: { xs: "100%", md: 656 },
        },
      }}
      header={dialogHeader}
      body={dialogBody}
      footer={
        <SHStack
          justifyContent="center"
          alignItems="center"
          direction={"row"}
          spacing={7}
        >
          <SHButton
            color="secondary"
            variant="text"
            size="extraMedium"
            onClick={onDiscard}
          >
            Discard
          </SHButton>
          <SHButton
            color="primary"
            size="extraMedium"
            variant="contained"
            onClick={onClose}
          >
            No, go back to setup
          </SHButton>
        </SHStack>
      }
    />
  );
};
